module.exports = __webpack_public_path__ + "img/hr-green-pita-02.5fa7fee4.png";